import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Headset, LifeBuoy } from "lucide-react";
import { ChatThread } from "@/components/chat/ChatThread";
import { ChatComposer } from "@/components/chat/ChatComposer";
import { RatingCard } from "@/components/chat/RatingCard";
import { ServiceBar } from "@/components/chat/ServiceBar";
import { api, errMsg } from "@/lib/api";
import { uploadChat } from "@/lib/chat";

export default function ChatAdmin() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const load = useCallback(() => api.get("/chat/messages").then((r) => {
    setData(r.data);
    window.dispatchEvent(new Event("cu-chat-read"));
  }).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [load]);

  const wrap = (fn) => async (...a) => {
    try {
      await fn(...a);
      await load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const t = data?.thread;
  return (
    <div className="flex flex-col h-[calc(100dvh-172px)] -mt-3" data-testid="member-chat-page">
      <div className="flex items-center gap-3 px-3 py-2.5 bg-emerald-700 text-white">
        <button onClick={() => navigate(-1)} data-testid="chat-back" aria-label="Kembali"><ArrowLeft className="h-5 w-5" /></button>
        <span className="h-10 w-10 rounded-full bg-white/20 flex items-center justify-center"><Headset className="h-5 w-5" /></span>
        <div className="leading-tight flex-1">
          <div className="font-semibold">Chat Admin CU</div>
          <div className="text-[11px] text-emerald-100" data-testid="chat-assigned">{t?.status === "closed" ? "Chat selesai • kirim pesan untuk memulai lagi" : data?.service && !data.service.open ? (data.service.holiday ? `Hari libur • dibalas ${data.service.next_open_label}` : `Di luar jam layanan • dibalas ${data.service.next_open_label}`) : t?.assigned_name ? `Dilayani oleh ${t.assigned_name}` : "Admin akan segera membalas"}</div>
        </div>
        <button onClick={() => navigate("/app/bantuan")} data-testid="chat-open-help" className="flex items-center gap-1 text-xs font-semibold bg-white/15 border border-white/30 rounded-full px-3 py-1.5"><LifeBuoy className="h-3.5 w-3.5" />Tiket</button>
      </div>
      <ChatThread messages={data?.messages} viewer="member" emptyText="Ceritakan kendala Anda. Tim admin CU Tuah Talino siap membantu." />
      <ServiceBar service={data?.service} />
      {t?.status === "closed" && t.rating_pending && <RatingCard staffName={t.closed_staff_name} onDone={load} />}
      <ChatComposer
        onText={wrap((text) => api.post("/chat/messages", { text }))}
        onFile={wrap((f, d) => uploadChat("/chat/upload", f, d))}
        onLocation={wrap((loc) => api.post("/chat/messages", loc))}
      />
      <p className="text-[10px] text-center text-slate-500 bg-[#f0f2f5] pb-1">Gambar, suara & PDF terhapus otomatis setelah 12 jam.</p>
    </div>
  );
}
